var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 4.78581H13.3334M6.66675 7.45247V11.4525M9.33341 7.45247V11.4525M3.33341 4.78581L4.00008 12.7858C4.00008 13.1394 4.14056 13.4786 4.39061 13.7286C4.64065 13.9787 4.97979 14.1191 5.33341 14.1191H10.6667C11.0204 14.1191 11.3595 13.9787 11.6096 13.7286C11.8596 13.4786 12.0001 13.1394 12.0001 12.7858L12.6667 4.78581M6.00008 4.78581V2.78581C6.00008 2.609 6.07032 2.43943 6.19534 2.3144C6.32037 2.18938 6.48994 2.11914 6.66675 2.11914H9.33341C9.51023 2.11914 9.6798 2.18938 9.80482 2.3144C9.92984 2.43943 10.0001 2.609 10.0001 2.78581V4.78581",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.20cfa6c87811fe0485f6b232384d1730.svg";
export { ForwardRef as ReactComponent };